import { CalendarDays, Clock, MapPin } from "lucide-react";

export function fmtDate(d) {
  if (!d) return "TBD";
  const dt = new Date(`${d}T00:00:00`);
  return dt.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
}

export function NextUp({ weeks, players, availability }) {
  const next = weeks.find((w) => !w.locked && w.date);
  if (!next) {
    return (
      <div className="fade-up rounded-xl border border-slate-200 bg-white p-4 text-center shadow-sm" data-testid="next-up-card">
        <p className="font-display text-xl uppercase tracking-wide text-slate-500">No upcoming games scheduled</p>
      </div>
    );
  }
  const confirmed = players.filter((p) => availability[`${p.id}:${next.id}`] === "available").length;
  return (
    <div className="fade-up rounded-xl border border-orange-500/30 bg-gradient-to-br from-orange-100/70 to-white p-4 shadow-sm" data-testid="next-up-card">
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-orange-400">Next up</p>
      <div className="mt-1.5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-2xl uppercase leading-none text-slate-900 sm:text-3xl" data-testid="next-up-opponent">
            {next.opponent ? `vs ${next.opponent}` : "Opponent TBD"}
          </h2>
          <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-600">
            <span className="inline-flex items-center gap-1.5" data-testid="next-up-date">
              <CalendarDays className="h-3.5 w-3.5 text-orange-400" /> {fmtDate(next.date)}
            </span>
            <span className="inline-flex items-center gap-1.5" data-testid="next-up-time">
              <Clock className="h-3.5 w-3.5 text-orange-400" /> {next.time || "Time TBD"}
            </span>
            <span className="inline-flex items-center gap-1.5" data-testid="next-up-location">
              <MapPin className="h-3.5 w-3.5 text-orange-400" /> {next.location || "Location TBD"}
            </span>
          </div>
        </div>
        <div className="text-right">
          <p className="font-display text-4xl leading-none text-orange-400" data-testid="next-up-confirmed-count">{confirmed}</p>
          <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">confirmed</p>
        </div>
      </div>
    </div>
  );
}
